import { render, staticRenderFns } from "./comp-tagihan.vue?vue&type=template&id=e55db060&scoped=true&"
import script from "./comp-tagihan.vue?vue&type=script&lang=js&"
export * from "./comp-tagihan.vue?vue&type=script&lang=js&"
import style0 from "./comp-tagihan.vue?vue&type=style&index=0&id=e55db060&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e55db060",
  null
  
)

export default component.exports